"use strict";

var _slicedToArray = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformGenericNFTForKey = exports.transformOpenseaResponse = exports.openseaDataToMetadata = void 0;

var RequestError_1 = require("./RequestError");

var TransformFetchResults_1 = require("./TransformFetchResults");

var openseaDataToMetadata = function openseaDataToMetadata(response) {
  return {
    name: response.openseaInfo.name,
    description: response.openseaInfo.description,
    image: response.openseaInfo.image_url,
    image_thumbnail_url: response.openseaInfo.image_thumbnail_url,
    animation_url: response.openseaInfo.animation_url
  };
};

exports.openseaDataToMetadata = openseaDataToMetadata;

var transformOpenseaResponse = function transformOpenseaResponse(data, auctionData, currencyData) {
  var _a;

  return {
    nft: {
      tokenId: data.token_id,
      contract: {
        address: data.asset_contract.address
      },
      owner: data.owner.address,
      creator: (_a = data.creator) === null || _a === void 0 ? void 0 : _a.address,
      metadataURI: data.token_metadata
    },
    openseaInfo: data,
    pricing: TransformFetchResults_1.addAuctionInformation({
      reserve: TransformFetchResults_1.auctionDataToPricing(auctionData)
    }, currencyData)
  };
};

exports.transformOpenseaResponse = transformOpenseaResponse;

var transformGenericNFTForKey = function transformGenericNFTForKey(response, key) {
  var _key$split = key.split(':'),
      _key$split2 = _slicedToArray(_key$split, 2),
      contractAddress = _key$split2[0],
      tokenId = _key$split2[1];

  var matchedResponse = response.find(function (response) {
    return response.token_id === tokenId && response.asset_contract.address === contractAddress;
  });

  if (!matchedResponse) {
    throw new RequestError_1.RequestError('Cannot find NFT in response');
  }

  return matchedResponse;
};

exports.transformGenericNFTForKey = transformGenericNFTForKey;